import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { useTheme } from '@emotion/react';
import { LinkButton as LinkButton$2 } from './LinkButton.styles.js';
import Button from '../Button/index.js';
import useWindowSize from '../../hooks/useWindowSize.js';
import { LINK_BUTTON } from '../../utils/dataTrackingValues.js';
import determineButtonText from '../../utils/determineButtonText.js';

var _excluded = ["children", "to", "requestId", "CustomLink", "customClasses", "mobileText", "visibility", "hideCobra", "text"];
var LinkButton = function LinkButton(_ref) {
  var _components$Button;
  var children = _ref.children,
    to = _ref.to,
    requestId = _ref.requestId,
    _ref$CustomLink = _ref.CustomLink,
    CustomLink = _ref$CustomLink === void 0 ? null : _ref$CustomLink,
    _ref$customClasses = _ref.customClasses,
    customClasses = _ref$customClasses === void 0 ? null : _ref$customClasses,
    _ref$mobileText = _ref.mobileText,
    mobileText = _ref$mobileText === void 0 ? null : _ref$mobileText,
    visibility = _ref.visibility,
    hideCobra = _ref.hideCobra,
    text = _ref.text,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    components = _useTheme.components;
  var windowSize = useWindowSize();
  var buttonText = determineButtonText(windowSize.width, mobileText, children || text // text is for Sylex
  );
  return /*#__PURE__*/React.createElement(LinkButton$2, {
    visibility: visibility,
    hideCobra: hideCobra,
    className: "leshen-link-button-wrapper",
    CustomLink: CustomLink,
    to: to
  }, /*#__PURE__*/React.createElement(Button, _extends({
    className: "leshen-link-button ".concat(customClasses),
    rounded: components === null || components === void 0 || (_components$Button = components.Button) === null || _components$Button === void 0 ? void 0 : _components$Button.rounded,
    onClick: function onClick() {
      return LINK_BUTTON.handleClick(children, CustomLink || to, requestId);
    }
    // eslint-disable-next-line react/jsx-curly-newline
  }, props), buttonText));
};
var LinkButton$1 = LinkButton;

export { LinkButton$1 as default };
//# sourceMappingURL=index.js.map
